__turbopack_context__.v({
  "title": "AccordionTitle-module__SU-ieq__title",
  "titleOpen": "AccordionTitle-module__SU-ieq__titleOpen",
});
